import Weather from './components/weather/weather';
import './App.css';

function App(props) {
  return (
    <div>
      <Weather  />

    </div>
 
   
  );
}

export default App;
